import { render } from "./ComponentDialog.vue?vue&type=template&id=10091006"
import script from "./ComponentDialog.vue?vue&type=script&lang=js"
export * from "./ComponentDialog.vue?vue&type=script&lang=js"

import "./ComponentDialog.vue?vue&type=style&index=0&id=10091006&lang=css"

import exportComponent from "C:\\hd\\git\\enuve\\app-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__